import { render, staticRenderFns } from "./DetailDia.vue?vue&type=template&id=33ea07cc&scoped=true&"
import script from "./DetailDia.vue?vue&type=script&lang=js&"
export * from "./DetailDia.vue?vue&type=script&lang=js&"
import style0 from "./DetailDia.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./DetailDia.vue?vue&type=style&index=1&id=33ea07cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea07cc",
  null
  
)

export default component.exports